<template>
  <div>
    <div
      v-if="shouldShowInlineForm"
      class="wrapper-x-40"
    >
      <Form
        :type="edit"
        :withoutImage="withoutImage"
      />
    </div>
    <div v-if="shouldShowList">
      <div class="wrapper-x-40 mb-30 action-panel flex justify-between">
        <div class="types__actions">
          <button
            class="btn btn-small btn-green"
            @click="addType"
          >
            <span><i class="fas fa-plus"></i></span>
            <span class="ml-2">{{$t('main.button_add')}}</span>
          </button>
          <button
            class="btn btn-small btn-red"
            @click="
              $store.dispatch('types/remove', deletes);
              deletes = [];
            "
          >
            <span><i class="fas fa-times"></i></span>
            <span class="ml-2">{{$t('main.button_delete')}}</span>
          </button>
          <button
            class="btn btn-small btn-default"
            @click="
              $store.dispatch('types/block', { deletes, status: 0 });
              deletes = [];
            "
          >
            <span><i class="fas fa-times"></i></span>
            <span class="ml-2">{{$t('main.button_block')}}</span>
          </button>
          <button
            class="btn btn-small btn-default"
            @click="
              $store.dispatch('types/block', { deletes, status: 1 });
              deletes = [];
            "
          >
            <span><i class="fas fa-check"></i></span>
            <span class="ml-2">{{$t('main.button_unblock')}}</span>
          </button>
        </div>
      </div>

      <div class="wrapper-x-40 types-list table-list-wrapper">
        <table>
          <thead>
            <tr>
              <th>
                <input
                  type="checkbox"
                  @change="changeCheck"
                />
              </th>
              <th
                class="image-name"
                colspan="2"
              >{{$t('main.label_list')}}:</th>
              <th class="article_template">
                {{$t('main.article_template')}}:
              </th>
              <th class="status">{{$t('main.label_status')}}:</th>
              <th class="id">ID:</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="type in types"
              :key="type.data.type_id"
            >
              <td class="checkbox">
                <input
                  type="checkbox"
                  ref="checkDeletes"
                  :value="type.data.type_id"
                  v-model="deletes"
                />
              </td>
              <td
                class="image"
                v-if="!withoutImage"
              >
                <button
                  @click="editType(type)"
                  class="image-preview"
                  v-if="type.data.attributes.image"
                >
                  <img
                    :src="type.data.attributes.image"
                    :alt="type.data.attributes.name"
                  />
                </button>
              </td>
              <td
                class="name"
                :colspan="withoutImage ? 2 : 1"
              >
                <button @click="editType(type)">
                  {{ type.data.attributes.name }}
                  <span v-if="model && model == 'App\\Models\\Material'">[{{ type.data.attributes.count_elements }}]</span>
                  <span v-else>[{{
                      `${type.data.attributes.count_elements_active} ${$t('main.label_active')} / ${type.data.attributes.count_elements_unactive} ${$t('main.label_unactive')}`
                    }}]</span>
                </button>
              </td>
              <td class="article_template">
                {{ type.data.attributes.article_template }}
              </td>
              <td class="status">
                <span
                  class="text-green-500"
                  :title="$t('main.published')"
                  v-if="type.data.attributes.status"
                ><i class="fas fa-check"></i></span>
                <span
                  class="text-red-500"
                  :title="$t('main.blocked')"
                  v-else
                ><i class="fas fa-times"></i></span>
              </td>
              <td class="id">{{ type.data.type_id }}</td>
            </tr>
          </tbody>
        </table>
        <PaginationBar
          :meta="meta"
          :page="page"
          :per-page="per_page"
          :per-pages="perPages"
          @set-page="setPage"
          @set-per-page="setPerPage"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Form from "./Form";
import PaginationBar from "../PaginationBar.vue";
export default {
  name: "List",
  components: { Form, PaginationBar },
  props: {
    withoutImage: {
      type: Boolean,
      default: false,
    },
    pageMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      deletes: [],
      selectPerPage: this.$store.state.types.per_page,
    };
  },
  methods: {
    getPageModeRoutes() {
      const routeName = String(this.$route.name ?? "");
      if (routeName === "elements_types") {
        return { add: "add_element_type", edit: "edit_element_type" };
      }
      if (routeName === "engravings_types") {
        return { add: "add_engraving_type", edit: "edit_engraving_type" };
      }
      if (routeName === "landscaping_types") {
        return { add: "add_landscaping_type", edit: "edit_landscaping_type" };
      }
      return null;
    },
    addType() {
      if (!this.isPageMode) {
        this.$store.dispatch("types/setAdd", true);
        return;
      }
      const routes = this.getPageModeRoutes();
      if (!routes?.add) return;
      this.$router
        .push({
          name: routes.add,
          params: { ...this.$route.params },
          query: { ...this.$route.query },
        })
        .catch((error) => {});
    },
    editType(type) {
      if (!this.isPageMode) {
        this.$store.dispatch("types/setEdit", type);
        return;
      }
      const routes = this.getPageModeRoutes();
      if (!routes?.edit) return;
      this.$router
        .push({
          name: routes.edit,
          params: { ...this.$route.params, type_id: type.data.type_id },
          query: { ...this.$route.query },
        })
        .catch((error) => {});
    },
    setPage(page) {
      this.$store.dispatch("types/setPage", page);
    },
    setPerPage(payload) {
      const perPage =
        typeof payload === "number"
          ? payload
          : Number(payload?.target?.value ?? this.per_page);
      this.$store.dispatch("types/setPerPage", perPage);
    },
    changeCheck(event) {
      this.deletes = [];
      if (event.target.checked) {
        this.$refs.checkDeletes.map((check) => {
          check.checked = true;
          this.deletes.push(check.value);
        });
      } else {
        this.$refs.checkDeletes.map((check) => (check.checked = false));
      }
    },
  },
  computed: {
    types() {
      return this.$store.state.types.types;
    },
    meta() {
      return this.$store.state.types.meta;
    },
    page() {
      return this.$store.state.types.page;
    },
    per_page() {
      return this.$store.state.types.per_page;
    },
    perPages() {
      return this.$store.state.settings.perPages;
    },
    add() {
      return this.$store.state.types.add;
    },
    edit() {
      return this.$store.state.types.edit;
    },
    model() {
      return this.$store.state.types.currentModel;
    },
    isPageMode() {
      if (this.pageMode) return true;
      const name = String(this.$route.name ?? "");
      return (
        name === "elements_types" ||
        name === "engravings_types" ||
        name === "landscaping_types"
      );
    },
    shouldShowInlineForm() {
      return !this.isPageMode && (this.add || this.edit);
    },
    shouldShowList() {
      return this.isPageMode || (!this.add && !this.edit);
    },
  },
};
</script>
<style scoped>
td.name,
td.name button {
  text-align: left;
}
td.image {
  width: 80px;
}
td.checkbox {
  width: 20px;
}
.types__actions {
  display: flex;
  gap: 10px;
}
</style>
